import { Layout, Menu, message, Button } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../public/assets/Logo";
import LogoCropped from "../../public/assets/LogoCropped";
import DashboardIcon from "../components/SidebarIcons/DashboardIcon";
import BlogIcon from "../components/SidebarIcons/BlogIcon";
import PharmaciesIcon from "../components/SidebarIcons/PharmaciesIcon";
import PharmacistsIcon from "../components/SidebarIcons/PharmacistsIcon";
import PatientsIcon from "../components/SidebarIcons/PatientsIcon";
import MedicinesIcon from "../components/SidebarIcons/MedicinesIcon";
import AdminsListIcon from "../components/SidebarIcons/AdminsListIcon";
import LogoutIcon from "../components/SidebarIcons/LogoutIcon";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PharmaciesListIcon from "../components/PharmaciesListIcon";
import DiseaseIcon from "../components/SidebarIcons/DiseaseIcon";
import OffersIcon from "../components/SidebarIcons/OffersIcon";
import FAQSIcon from "../components/SidebarIcons/FAQSIcon";
import axios from "axios";
import { CloseOutlined } from "@ant-design/icons";
import useResponsive from "../hooks/useResponsive";

const { Sider } = Layout;

const Sidebar = () => {
  // Use our custom hook for responsive state and actions
  const {
    isSidebarCollapsed,
    isResponsiveMode,
    setSidebarCollapsed
  } = useResponsive();

  // change usertype from api user id
  const userType = useSelector((state) => state.user?.user?.roleDetails?.id);
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state.user.accessToken)

  // here Extract the part after the second "/ " to get dashboard or something ...
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState(() => {
    const pathParts = location.pathname.split("/");
    return pathParts[2] || "dashboard";
  });

  useEffect(() => {
    const pathParts = location.pathname.split("/");
    const key = pathParts[2] || "dashboard";
    setSelectedKey(key);
  }, [location]);

  // Construct the path based on the user type.
  const getPath = (basePath) => {
    switch (userType) {
      case 1:
        return `/Sadmin${basePath}`;
      case 2:
        return `/pharmacist${basePath}`;
      case 4:
        return `/Padmin${basePath}`;
      default:
        throw new Error("Invalid user type");
    }
  };

  const handleLogout = async () => {
    if (accessToken) {
      try {
        const url = `${import.meta.env.VITE_API_URL}/userDevices/FcmDestroy`;
        const headers = {
          Authorization: `Bearer ${accessToken}`,
        };
        await axios.delete(url, { headers });
      } catch (error) {
        console.error("Failed to destroy FCM session during logout:", error);
        // Continue with logout even if FCM destruction fails
      }
    }
    message.success("Logged out Successfully");

    localStorage.clear();
    sessionStorage.clear();

    setTimeout(() => {
      window.location.reload();
    }, 200);
  };

  // Function to handle menu item click
  const handleMenuItemClick = () => {
    if (isResponsiveMode) {
      setSidebarCollapsed(true);
    }
  };

  // Sidebar menu items based on the user type.
  const menuItems =
    [1, 4].includes(userType)
      ? [
        {
          key: "dashboard",
          label: <Link to={getPath("/dashboard")}>Dashboard</Link>,
          icon: <DashboardIcon />,
        },
        {
          key: "patients",
          label: <Link to={getPath("/patients")}>Patients</Link>,
          icon: <PatientsIcon />,
        },
        {
          key: "pharmacies",
          label: <Link to={getPath("/pharmacies")}>Pharmacies</Link>,
          icon: <PharmaciesIcon />,
        },
        {
          key: "pharmacists",
          label: <Link to={getPath("/pharmacists")}>Pharmacists</Link>,
          icon: <PharmacistsIcon />,
        },
        {
          key: "medicines",
          label: <Link to={getPath("/medicines")}>Medicines</Link>,
          icon: <MedicinesIcon />,
        },
        {
          key: "Offers",
          label: <Link to={getPath("/Offers")}>Offers</Link>,
          icon: <OffersIcon />,
        },
        {
          key: "blog",
          label: <Link to={getPath("/blog")}>Blogs</Link>,
          icon: <BlogIcon />,
        },
        ...(userType === 1
          ? [
            {
              key: "FAQ",
              label: <Link to={getPath("/FAQ")}>FAQ</Link>,
              icon: <FAQSIcon />,
            },
            {
              key: "Diseases",
              label: <Link to={getPath("/Diseases")}>Diseases</Link>,
              icon: <DiseaseIcon />,
            },

            {
              key: "PharmaciesAdminsList",
              label: <Link to={getPath("/PharmaciesAdminsList")}>Pharmacies Admins List</Link>,
              icon: <PharmaciesListIcon />,
            },
            {
              key: "AdminsList",
              label: <Link to={getPath("/AdminsList")}>Super Admins List</Link>,
              icon: <AdminsListIcon />,
            },

          ]
          : []),
        {
          key: "logoutIcon",
          label: "Logout",
          icon: <LogoutIcon />,
          onClick: handleLogout,
        },
      ]
      : [
        {
          key: "dashboard",
          label: <Link to={getPath("/dashboard")}>Dashboard</Link>,
          icon: <DashboardIcon />,
        },
        {
          key: "patients",
          label: <Link to={getPath("/patients")}>Patients</Link>,
          icon: <PatientsIcon />,
        },
        {
          key: "logoutIcon",
          label: "Logout",
          icon: <LogoutIcon />,
          onClick: handleLogout,
        },
      ];

  return (
    <Sider
      width={isResponsiveMode ? "100%" : "20vw"}
      trigger={null}
      collapsible
      collapsed={isSidebarCollapsed}
      className={`sidebar-wrapper ant-menu-light ant-menu-root ant-menu-vertical bg-white px-4 ${isResponsiveMode ? "fixed z-50 h-full responsive-sidebar" : ""
        }`}
      style={{
        position: isResponsiveMode ? "fixed" : "relative",
        left: isResponsiveMode && !isSidebarCollapsed ? 0 : (isResponsiveMode ? "-100%" : "auto"),
        transition: "all 0.3s",
        display: isResponsiveMode && isSidebarCollapsed ? "none" : "block",
        height: isResponsiveMode ? "100%" : "auto",
        overflowY: "auto",
        paddingBottom: isResponsiveMode ? "20px" : "0",
      }}
    >
      <div className="flex justify-between items-center mt-4 sticky top-0 bg-white z-10 pb-2">
        <Link to={getPath("/dashboard")}>
          {!isSidebarCollapsed && <Logo />}
          {isSidebarCollapsed && <LogoCropped />}
        </Link>
        {isResponsiveMode && !isSidebarCollapsed && (
          <Button
            type="text"
            className="close-sidebar-btn"
            icon={<CloseOutlined />}
            onClick={() => setSidebarCollapsed(true)}
          />
        )}
      </div>
      <div className={`${isResponsiveMode ? "sidebar-menu-container" : ""}`}>
        <Menu
          theme="light"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          className="my-custom-menu sidebarMenu"
          onClick={handleMenuItemClick}
        />
      </div>
    </Sider>
  );
};

export default Sidebar;
